module.exports = __webpack_public_path__ + "img/kosten-pellets.36c8304.webp";